import { Col, Row, Space, Table } from "antd";
import { useTranslation } from "react-i18next";
import Header from "./header";
import ViewButton from "../UI/ViewButton/viewbutton";

type PropsType = {
  picker: string;
};

const DashboardHistoryList = ({ picker }: PropsType) => {
  const { t } = useTranslation("common");
  const dataSource = [
    {
      key: "1",
      type: "Mike",
      invoice: 32,
      date: "YYYY/MM/DD",
      price: 23,
      description: "something...",
      quantity: 99,
      total: 111,
    },
    {
      key: "1",
      type: "Mike",
      invoice: 32,
      date: "YYYY/MM/DD",
      price: 23,
      description: "something...",
      quantity: 99,
      total: 111,
    },
  ];

  const columns = [
    {
      title: `${t("transactiont-type")}`,
      dataIndex: "type",
      key: "type",
    },
    {
      title: `${t("invoice-number")}`,
      dataIndex: "invoice",
      key: "invoice",
      align: "center" as "center",
    },
    {
      title: `${t("date")}`,
      dataIndex: "date",
      key: "date",
      align: "center" as "center",
    },
    {
      title: `${t("description")}`,
      dataIndex: "description",
      key: "description",
      align: "center" as "center",
    },
    {
      title: `${t("quantity")}`,
      dataIndex: "quantity",
      key: "quantity",
      align: "center" as "center",
    },
    {
      title: `${t("price")}`,
      dataIndex: "price",
      key: "price",
      align: "center" as "center",
    },
    {
      title: `${t("total")}`,
      dataIndex: "total",
      key: "total",
      align: "center" as "center",
    },
    {
      title: `${t("action")}`,
      key: "action",
      align: "center" as "center",
      render: (record: any) => (
        <Space size="middle">
          <ViewButton onClick={() => console.log("hh")} />
        </Space>
      ),
    },
  ];
  return (
    <Row>
      <Col offset={1} span={22}>
        <Header picker={picker} hasItems={true} placeholder="Wearhouse" />
        <Table
          scroll={{ x: 1000 }}
          dataSource={dataSource}
          columns={columns}
          rowClassName={(record, index) =>
            index % 2 === 0
              ? "table-row-light table-row"
              : "table-row-dark table-row"
          }
          style={{ marginTop: "15px" }}
        />
      </Col>
    </Row>
  );
};

export default DashboardHistoryList;
